module.exports = flarum.core.compat['components/DashboardWidget'];